<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig?.isLoading"
    (filterChange)="getReportByOperatorData($event)"
></mt-filter>

<div class="report-container mt-4" *ngIf="hasData || message || systemError">
    <div class="header-container">
        <div class="header">
            <div class="float-left title">
                {{ "report-loops-by-operator" | lang | uppercase }}
            </div>
            <div class="float-right" *ngIf="canDownload && hasData">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'body-container': hasData }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="error"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <div class="result-container" *ngIf="hasData">
            <div class="row">
                <div class="col-6">
                    <!--Cards ByShift-->
                    <app-transfer-by-shift-cards
                        [transferByShiftList]="reportResult?.totalLoopsByShift"
                    >
                    </app-transfer-by-shift-cards>
                </div>
                <div class="col-6">
                    <!--Table ByShift-->
                    <app-transfer-by-machine-shift-table
                        [transferByMachineTable]="
                            reportResult?.totalLoopsByMachine
                                ? reportResult?.totalLoopsByMachine
                                : reportResult?.totalLoopsByOperator
                        "
                    >
                    </app-transfer-by-machine-shift-table>
                </div>
            </div>
            <div class="row mx-2">
                <div class="col-12">
                    <!--Table Details Operator Loops Report-->
                    <app-loop-by-operator-filter-result
                        [filteredResult]="reportResult?.loopsDetailByDate"
                    ></app-loop-by-operator-filter-result>
                </div>
            </div>
        </div>
    </div>
</div>
